const Utils = {};

/**
 * [判断空对象]
 * @param {[object]} obj
 * @return {[boolean]}
 */
Utils.isEmptyObject = obj => JSON.stringify(obj) === "{}";

/**
 * 判断数据类型
 * @param {Array} obj 待判断的数据
 * @author hanshuo
 */
Utils.typeOf = obj => {
  const toString = Object.prototype.toString;
  const map = {
    "[object Boolean]": "boolean",
    "[object Number]": "number",
    "[object String]": "string",
    "[object Function]": "function",
    "[object Array]": "array",
    "[object Date]": "date",
    "[object RegExp]": "regExp",
    "[object Undefined]": "undefined",
    "[object Null]": "null",
    "[object Object]": "object"
  };
  return map[toString.call(obj)];
};

//时间戳转yyyy-MM-dd
//more为true，精确到时分秒
Utils.formatDate = (date, more) => {
  if (!date) {
    return '-';
  }
  let d = null;
  if (date.toString().length === 10) {
    d = new Date(parseInt(date) * 1000);
  } else {
    d = new Date(date);
  }
  
  if (!more) {
    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
  } else {
    let hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
    let minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
    let seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();
    return (
      d.getFullYear() +
      '-' +
      (d.getMonth() + 1) +
      '-' +
      d.getDate() +
      ' ' +
      hours +
      ':' +
      minutes +
      ':' +
      seconds
    );
  }
}


export default Utils;